import { configResponsive, useResponsive } from "ahooks";

import { useMemo } from "react";

configResponsive({
  breakPoint: 700,
});

export enum PlatformType {
  PC = "pc",
  Mobile = "mobile",
}

const usePlatform = () => {
  const response = useResponsive();

  return useMemo(
    () => ({
      platform: response.breakPoint ? PlatformType.PC : PlatformType.Mobile,
      isMobile: !response.breakPoint,
      isPc: response.breakPoint,
    }),
    [response]
  );
};

export default usePlatform;
